import { render, staticRenderFns } from "./manageClass.vue?vue&type=template&id=4d9a925a&scoped=true&"
import script from "./manageClass.js?vue&type=script&lang=js&"
export * from "./manageClass.js?vue&type=script&lang=js&"
import style0 from "./manageClass.vue?vue&type=style&index=0&id=4d9a925a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a925a",
  null
  
)

export default component.exports